<template>
  <b-container style="margin-top:15px">
    <b-row>
      <b-card-group deck v-loading="loading">
        <b-card header="Sayfa Düzenle" header-tag="header">
            <b-row>
              <b-col cols="2">
                  <b-form-group label="Sayfa Adı">
                    <b-form-input size="sm" v-model="form.title" placeholder="Sayfa Adı"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Sayfa Url">
                    <b-form-input size="sm" v-model="form.url" placeholder="Url"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                  <b-form-group label="Durum">
                    <b-form-select size="sm" v-model="form.status" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="1">Aktif</b-form-select-option>
                      <b-form-select-option :value="0">Pasif</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="12">
                  <b-form-group label="Sayfa İçeriği">
		                <ckeditor v-model="form.body"></ckeditor>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Güncelle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'PagesDetail',
    data(){
      return{
        slug: this.$route.params.slug,
        loading: false,
        form:{
          title:null,
          body:null,
          url:null,
          status:null,
        }
      }
    },
    created(){
      this.fetch();
    },
    methods:{
      fetch(){
        this.loading = true;
        axios.get('/page/' + this.slug + '/detail')
        .then((response) => {
            this.form = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
      send(){
        this.loading = true;
        axios.post('/page/' + this.form.id + '/update', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            this.$router.push({name: 'Pages'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>